// Header height
let headerHeight = 0;
window.addEventListener("load", () => {
  const header = document.querySelector("header");
  headerHeight = header.style.height;
})

// Image Slideshow
// select the prev and next buttons
const slideButtons = document.querySelectorAll("[data-slide-button]");

slideButtons.forEach(button => {
  button.addEventListener("click", () => {
    const offset = button.dataset.slideButton === "next" ? 1 : -1;
    // slideshow is the container of all images
    const slideshow = button
                      .closest("[data-slideshow]")
                      .querySelector("[data-slides-container]");
    const activeSlide = button
                      .closest("[data-slideshow]")
                      .querySelector("[data-slides-container]")
                      .querySelector("[data-active]");
    
    let newIndex = [...slideshow.children].indexOf(activeSlide) + offset;
    let prevIndex = newIndex - 1;
    let nextIndex = newIndex + 1;

    if (newIndex == 0) {
      prevIndex = slideshow.children.length - 1;
    }

    if (newIndex == slideshow.children.length - 1) {
      nextIndex = 0;
    }
    // newIndex will be the last image if no more prev img
    if (newIndex < 0) {
      newIndex = slideshow.children.length - 1;
      prevIndex = newIndex - 1;
      nextIndex = 0;
    }
    // newIndex will the first image if no more next img
    if (newIndex >= slideshow.children.length) {
      newIndex = 0;
      prevIndex = slideshow.children.length - 1;
      nextIndex = newIndex + 1;
    }
   
    console.log("check prevIndex: " + prevIndex);
    console.log("check nextIndex: " + nextIndex);
    slideshow.children[prevIndex].style.transform = "translateX(-10px)";
    slideshow.children[nextIndex].style.transform = "translateX(10px)";
    slideshow.children[newIndex].style.transform = "translateX(0)";
    slideshow.children[newIndex].dataset.active = true;

    delete activeSlide.dataset.active;
  })
})



// Mobile Nav Sidebar Toggle
const navButtons = document.querySelectorAll("[data-nav-button]");
const aside = document.querySelector("[data-aside]");

navButtons.forEach((button) => {
  button.addEventListener("click", () => {
    let navStatus = aside.dataset.nav.toString();
    if (navStatus === "close") {
      aside.dataset.nav = "open";
    } else {
      aside.dataset.nav = "close";
    }
  })
})

// Mobile Sub-Nav Toggle
const subnavButtons = document.querySelectorAll("[data-subnav-button]");

subnavButtons.forEach(button => {
  button.addEventListener("click", () => {
    const subNav = button.closest("li")
                         .querySelector("[data-subnav]");

    const subNavStatus = subNav.dataset.subnav.toString();
    console.log("Check subnav: " + subNavStatus);
    if (subNavStatus === "close") {
      subNav.dataset.subnav = "open";
      subNav.classList.toggle("subnav-open");
    } else {
      subNav.dataset.subnav = "close";
      subNav.classList.toggle("subnav-open");
    }
  })
})

// Mobile Level 2 Site Path Home
const pathHomeButtons = document.querySelectorAll("[data-path-home]");

pathHomeButtons.forEach(button => {
  button.addEventListener("click", () => {
    const subNav = button.closest("li")
                         .querySelector("[data-subnav]");

    const subNavStatus = subNav.dataset.subnav.toString();
    if (subNavStatus === "close") {
      subNav.dataset.subnav = "open";
    } else {
      subNav.dataset.subnav = "close";
    }
  })
})

// Mobile Level 3 Site Path {{ link }}
const pathLinkButtons = document.querySelectorAll("[data-path-link]");

pathLinkButtons.forEach(button => {
  button.addEventListener("click", () => {
    const subNav = button.closest("li")
                         .querySelector("[data-subnav]");

    const subNavStatus = subNav.dataset.subnav.toString();
    if (subNavStatus === "close") {
      subNav.dataset.subnav = "open";
    } else {
      subNav.dataset.subnav = "close";
    }
  })
})


// Burger button 
const burgerButtons = document.querySelectorAll("[data-burger]");

burgerButtons.forEach(button => {
  button.addEventListener("click", () => {
    console.log('clicked');
    let burgerStatus = button.dataset.burger.toString();
    if (burgerStatus === "close") {
      button.dataset.burger = "open";
      button.classList.add('active'); // .active let the burger top and bottom use tailwindcss group-[.*] for styling
    } else {
      button.dataset.burger = "close";
      button.classList.remove('active');
    }
  })
})



// toggle cart drawer
const headerCartButtons = document.querySelectorAll("[data-header-cart-btn]");

if (headerCartButtons) {
  headerCartButtons.forEach(button => {
    button.addEventListener("click", () => {
      const cartDrawer = document.querySelector("[data-cart-drawer-wrapper]");

      if (cartDrawer) {
        if (cartDrawer.dataset.cartDrawerWrapper === "close") {
          cartDrawer.dataset.cartDrawerWrapper = "open";
        }
      }
    })
  })
}



// Search button
const searchButtons = document.querySelectorAll("[data-search-btn]");
searchButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const searchForm = button.closest("[data-search-wrapper]")
                              .querySelector("[data-search-form]");
    
    if (searchForm.dataset.searchForm === "close") {
      searchForm.dataset.searchForm = "open";
    } else {
      searchForm.dataset.searchForm = "close";
    }
  })
})

// close search form if clicked anywhere outside of input
const searchFormSurrounds = document.querySelectorAll("[data-search-form-surround]");

searchFormSurrounds.forEach((surround) => {
  surround.addEventListener("click", () => {
    const searchForm = surround.closest("[data-search-form]");

    if (searchForm.dataset.searchForm === "open") {
      searchForm.dataset.searchForm = "close";
    }
  })
})

// stop the previous close search form for the input element inside the form
const searchFormInputs = document.querySelectorAll("[data-search-form-input]");

searchFormInputs.forEach((input) => {
  input.addEventListener("click", (e) => {
    e.stopPropagation();
  })
})



// Header Language Form
/* const langButtons = document.querySelectorAll("[data-lang-form-btn]");

if (langButtons) {
  langButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const langForm = button.closest("[data-lang-form-wrapper]")
                             .querySelector("[data-lang-form]");
      if (langForm) {
        if (langForm.dataset.langForm === "close") {
          langForm.dataset.langForm = "open";
        }
      }
    })
  })
} */



// Toggle Level3 Menu
const level3Buttons = document.querySelectorAll("[data-level3-btn]");

level3Buttons.forEach((button) => {
  button.addEventListener("click", () => {

    level3Buttons.forEach((button) => {
      button.dataset.level3Btn = "close";
    })

    button.dataset.level3Btn = "open";

    const title = button.dataset.level2Title;
    const level3Menus = document.querySelectorAll("[data-level3-menu]");

    level3Menus.forEach((menu) => {
      // match the level 3 menu with the clicked button
      if (menu.dataset.level2Title === title) {
        menu.dataset.level3Menu = "open";
      } else {
        // close all other level 3 menus
        menu.dataset.level3Menu = "close";
      }
    })

  })
})
